module.exports = __webpack_public_path__ + "static/media/Inaugural.f1086760.png";